// Loads an unprepared checkout widget through the server's payment preparation endpoint.
// Asks its Dynamic Frame to reload and manages loading/retry UI; the provider owns payment collection.
import { registerFunctionalComponent } from 'js/lib/components/component'
import { on } from 'js/lib/events'
import { getFrame } from 'components/dynamic/frame/component'
import { notifyBugsnag } from 'js/lib/bugsnag'

registerFunctionalComponent('.js-c-payments-checkout', 'PaymentsCheckout', initCheckout)

function initCheckout(component) {
  const root = component.element
  if (root.dataset.prepared === 'true') return

  const frame = getFrame(root)
  const loading = root.querySelector('.js-c-payments-checkout-loading')
  const error = root.querySelector('.js-c-payments-checkout-error')
  let pending = false
  let unmounted = false

  component.useHandler(() => on('click', root.querySelector('.js-c-payments-checkout-retry'), load))
  component.useHandler(() => () => { unmounted = true })
  load()

  // Loading is a mutating POST: Flow may write an attempt and contact Stripe, not just render HTML.
  // The frame ignores detached responses; ignore duplicate clicks while a request is in flight.
  async function load() {
    if (pending || unmounted) return
    pending = true
    root.setAttribute('aria-busy', 'true')
    loading.hidden = false
    error.hidden = true

    try {
      // The frame supplies its signed endpoint and identity, never host form data.
      await frame.reload()
    } catch (failure) {
      if (unmounted) return
      loading.hidden = true
      error.hidden = false
      notifyBugsnag(failure instanceof Error ? failure : new Error('Payment form could not be loaded'))
    } finally {
      pending = false
      if (!unmounted) root.setAttribute('aria-busy', 'false')
    }
  }
}
